import { useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { Button, type ButtonProps } from "@/components/ui/button"
import { useAppDispatch } from "@/store/hooks"
import { addProduct, type CartProduct } from "@/store/slices/cartSlice"
import { getItemName } from "@/content/prices"

interface AddToCartButtonProps {
	cartItem: CartProduct
	text?: string
	variant?: ButtonProps["variant"]
	size?: ButtonProps["size"]
	className?: string
	/** Si se define, navega a esta ruta tras agregar al carrito (p. ej. `/checkout`). */
	redirectTo?: string
}

/**
 * Botón que agrega un ítem al carrito de Redux y muestra un toast de confirmación.
 * Contraparte de `BuyNowButton` (que va directo a Stripe). Reutilizable en fichas
 * de producto, tratamiento y CTAs. Con `redirectTo` navega al carrito tras agregar.
 */
export default function AddToCartButton({
	cartItem,
	text = "Agregar al carrito",
	variant = "outline",
	size = "default",
	className,
	redirectTo
}: AddToCartButtonProps): React.JSX.Element {
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	function handleAddToCart(): void {
		dispatch(addProduct(cartItem))
		toast.success(`${getItemName(cartItem.id)} agregado al carrito`)
		if (redirectTo) navigate(redirectTo)
	}

	return (
		<Button variant={variant} size={size} className={className} onClick={handleAddToCart}>
			{text}
		</Button>
	)
}
